import ChatActions from "../../actions/ChatActions";
import alt from "../../alt/ChatAlt";

export class ChatListStore {
    constructor() {
        this.bindActions(ChatActions);
        this.lastUpdated = null;
        this.lastViewedDateTime = null;
        this.openChatList = [];
        this.closedChatList = [];
        this.isLoading = true;
    }

    onViewChatList() {
        this.lastUpdated = null;
    }

    onListSuccess(payload) {
        this.isLoading = false;
        this.lastUpdated = payload.lastUpdated;
        this.openChatList = payload.openChatList;
        this.closedChatList = payload.closedChatList;
    }

    onListFail() {
        // TODO: do something with the error
        this.isLoading = false;
    }

    static getOpenChatListCount() {
        return this.getState().openChatList.length;
    }

    static getUnreadChatsCount() {
        let count = 0;
        for (let i = this.getState().openChatList.length - 1; i >= 0; i--) {
            const question = this.getState().openChatList[i].chat.question;
            count += question.unreadMessageCount;
        }
        for (let i = this.getState().closedChatList.length - 1; i >= 0; i--) {
            const question = this.getState().closedChatList[i].chat.question;
            count += question.unreadMessageCount;
        }
        return count;
    }
}

export default alt.createStore(ChatListStore, "ChatListStore");
